import {  Directive, ElementRef, HostListener , Renderer2,Injectable,Component, OnInit,Input, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { TranslationService, I18nModule } from '@spartacus/core';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { TenderPricingOptionConfirmBidComponent } from '../tender-pricing-option-confirm-bid/tender-pricing-option-confirm-bid.component';
import { TenderSelectProductsComponent } from '../tender-select-products/tender-select-products.component';
import { TenderConfirmBidModalComponent } from '../tender-confirm-bid-modal/tender-confirm-bid-modal.component';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { AllowNegativeDecimalNumber, CopyDirective, CommonDigitsDirective, TwoDigitDecimaNumberDirective } from '../two-digit-decima-number.directive';
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}
@Component({
    selector: 'app-tender-pricing-option',
    templateUrl: './tender-pricing-option.component.html',
    styleUrls: ['./tender-pricing-option.component.scss'],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
    imports: [NgIf, FormsModule, NgFor, ReactiveFormsModule, NgbInputDatepicker, AllowNegativeDecimalNumber, CopyDirective, CommonDigitsDirective, TwoDigitDecimaNumberDirective, DecimalPipe, DatePipe, I18nModule]
})
export class TenderPricingOptionComponent implements OnInit {
  QPstartDate: NgbDate = null;
  QPendDate: NgbDate = null;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  form: UntypedFormGroup;
  @Input() qpStartDt;
  @Input() qpEndDt;
  qpSD:any;
  qpED:any;
  finalQPFromoDateErr:boolean=false;
finalQPToDateErr:boolean=false
isFinalQPFromDateValid:boolean=false
isFinalQPToDateValid:boolean=false
isFinalQPToGreater:boolean=false
convertedDate: any;
  hoveredDate: NgbDate | null = null;
  private modalRef: NgbModalRef;
  div1:boolean=true;
  activeTab = 'none';
  priceTab= 'none';
  COI: boolean =false;
  OpenNegotiation:boolean=true;
  @Input() value:any;
  @Input() productsInfo: any;
  @Input() productsEntry:any
  @Input() price:any;
  @Input() indexPrice:number;
  @Input() tabName: any;
  @Input() selectProduct:any;
  @Input() parameter=[];
  @Input() indexValue:any;
  @Input() quantity:any;
  @Input() quantityshw:any;
  @Input() dischargePortshw:any;
  productInfo:any;
  priceVal: any;
  a:any;
  checkbox:any;
  isHidden: boolean = false;
 // qpDatesRequired: boolean = false;
  priceEmpty:boolean = false;
  qpChoice:any="";
  displayFixedQPSection =false;
  defaultValue:any = null;
  QPValuSelectedError: boolean =false;
  constructor(public calendar: NgbCalendar, public formatter: NgbDateParserFormatter,
    public ActiveModal: NgbActiveModal,private config:NgbDatepickerConfig,
    public ModalService:NgbModal,private modalService: NgbModal,public customProductService:CustomProductsService) { 
    const current = new Date();
    config.minDate = { 
                       year:current.getFullYear(),month:
                       current.getMonth()+1,day:current.getDate()
                    };
    config.outsideDays='hidden';
  }

  ngOnInit(): void {
    this.productInfo=this.productsInfo;
    if (this.productInfo?.combinedTenders?.length ==1){
this.a=this.productInfo ?.combinedTenders[0];
console.log(this.a,'max');
// this.a.pricingOptionsEnum.forEach(e => {
//   e.qp=[];
//   if(this.defaultValue === null){
//     e.qp.push({"description": e.qpMultipleChoices[0]?.description, "uniqueRowNumber":e.qpMultipleChoices[0]?.uniqueRowNumber})
//   }
// });

if(this.quantity){
  this.value=this.quantity
}else{
  this.value=this.a.maximumQuantity
}
    }else{
      this.productInfo=this.selectProduct;
      if(this.productsEntry.length==1){
        this.a=this.productsEntry[0]
        if(this.quantity){
          this.value=this.quantity
        }else{
          this.value=this.a.maximumQuantity
        }
      }else{
        this.a=this.productsEntry;
        
      }
    }
    this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl(),
      finalQPFromDate: new UntypedFormControl(this.a.finalQPFromDate ? this.a.finalQPFromDate : null),
      finalQPToDate: new UntypedFormControl(this.a.finalQPToDate ? this.a.finalQPToDate : null)
    });
    this.qpStartDt=this.a.finalQPFromDate? this.changeStartEndDate(this.a.finalQPFromDate) : null;
    this.qpEndDt=this.a.finalQPToDate ?this.changeStartEndDate(this.a.finalQPToDate) : null;
    this.form.controls['finalQPFromDate'].setValue(this.qpStartDt);
    this.form.controls['finalQPToDate'].setValue(this.qpEndDt);
    console.log(this.qpStartDt,'qpStartDt')
    console.log(this.qpEndDt,'qpEndDt')
    // if(this.qpStartDt && this.qpStartDt){
    //   this.qpDatesRequired = true;
    // }else{
    //   this.qpDatesRequired = false;
    // }
  }
  qpChangeAction(event:any, index, options:any){ 
    this.QPValuSelectedError = false;
    options.pricingOptionsEnum[0].qp=[];    
    if(event.target.value === 'Fixed QP'){     
      this.displayFixedQPSection = true;
    }else{
      this.displayFixedQPSection = false;
    }
    let valueSelected = options.pricingOptionsEnum[0].qpMultipleChoices.find(x=>x.description == event.target.value);
    
    options.pricingOptionsEnum[0].qp.push(valueSelected);
  }
  changeStartEndDate(date){
    var laycanDate = this.getDateinCorrectFormat(date);
    return laycanDate;
  }
  getDateinCorrectFormat(selectedDate){
    var formattedDate = new Date(selectedDate).getDate() + '-' + (new Date(selectedDate).getMonth()+1) + '-' + new Date(selectedDate).getFullYear();
    return formattedDate;
  }

  setTitle(value){
    switch(value){
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default : return;
    }
  }
  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for(let i=0;i<element3.length;i++){
      let value = element3[i].getAttribute("title");
      console.log(value);
      element3[i].setAttribute("title",this.setTitle(value));
    }

   let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
   for(let i=0;i<element4.length;i++){
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title",this.setTitle(value))
   }
  }
  checkPad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
}
  defaultDate(){
    let date = new Date();
    this.convertedDate = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
  }
  qpFromDateSelection(selectedDate) {
    if(selectedDate == null){
      this.QPstartDate = null;
      this.QPendDate = null;
     }
     else{
      this.isFinalQPFromDateValid=false;
     this.defaultDate();
    //  this.counterOfferError = false;
    //  this.counterOfferErrorValue = '';
    //  this.showDateError = false;
     this.QPstartDate = selectedDate;
    this.QPendDate=selectedDate
     this.convertedDate = selectedDate;
     this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
     const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
     this.qpSD=dateTime.format();
     }
  }
  qpToDateSelection(selectedDate){
    if(selectedDate == null){
      this.QPstartDate = null;
      this.QPendDate = null;
     }
     else{
      this.isFinalQPToGreater=false;
      this.isFinalQPToDateValid=false;
     this.defaultDate();
    //  this.counterOfferError = false;
    //  this.counterOfferErrorValue = '';
    //  this.showDateError = false;
     this.QPstartDate = selectedDate;
    this.QPendDate=selectedDate
     this.convertedDate = selectedDate;
     this.convertedDate = selectedDate.year + '-' + this.checkPad(selectedDate.month) + '-' + this.checkPad(selectedDate.day);
     const dateTime = moment(this.convertedDate, + '00:00' + 'YYYY-MM-DD HH:mm');
     this.qpED=dateTime.format();
     }
  } 
  toolTipShow(i){
    this.isHidden = true
    const hover = document.getElementById('differential_values' + i);
    hover.style.display = 'block'
  }
  toolTipHide(i){
    const hover = document.getElementById('differential_values' + i);
    hover.style.display = 'none'
  }
  divide(){
    if(!isNaN(this.price)){
      //this.price = Math.abs(this.price)
      this.indexPrice= (this.price/ 1000);
      this.indexPrice = Number(this.indexPrice.toFixed(5));
    }
    else{
      this.price = null;
      this.indexPrice = null;
    }
    }
  childDivide(){
    if(this.productInfo.commodityType=='CN' && this.a.childList==undefined){
      this.indexPrice= (this.price/ 1000);
    }
  }
  
  close(): any {
    this.ActiveModal.close();
    //this.a.pricingOptionsEnum[0].pricingOptions='';
  }
omit_special_char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   
   let booleanValue = ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k==46 ||(k >= 48 && k <= 57)); 
   console.log(booleanValue);
   return booleanValue;
}
Omit_Special_Char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32|| k==45 || k==46 ||(k >= 48 && k <= 57)); 
}
checkpriceEnteredorNot(){
  if(this.a.childList){
    this.a.childList.forEach(x => {
      if(x.price==0 || x.price == undefined|| x.price ==''){
        x.priceEmpty = true;
      }
      else{
        x.priceEmpty = false;
      }
    });
    if(this.a.childList.filter(x=>{return x.priceEmpty == true}).length>0){
      this.priceEmpty = true;
    }
    else{
      this.priceEmpty = false;
    }
    return this.priceEmpty;
  }
  else{
    if(this.productInfo.commodityType!='IO'){
      if(this.productInfo.commodityType=='CA' && this.productInfo.combinedTenders[0].pricingOptionsEnum[0].pricingOptions=='FLOATING_PREMIUM'){
        this.priceEmpty = false;
        return this.priceEmpty;
      }
      else{
        if(this.price==0||this.price==undefined||this.price==''  ){
          this.priceEmpty = true;
        }
        else{
          this.priceEmpty = false;
        }
        return this.priceEmpty
      }
      
    }
    else{
      this.priceEmpty = false;
      return this.priceEmpty
    }
   
  }
}

checkQPdateValidation(){
  let flag: boolean;
    //to check to and from date required
    if( this.form.value.finalQPToDate == '' || this.form.value.finalQPToDate == null){
      this.isFinalQPToDateValid = true;
      //flag = this.isFinalQPToDateValid;
    }
    if(this.form.value.finalQPFromDate == '' || this.form.value.finalQPFromDate ==null){
      this.isFinalQPFromDateValid = true;
    // flag = this.isFinalQPToDateValid;
    }
  // to check to date is grater than from date
    if(!this.isFinalQPToDateValid && !this.isFinalQPFromDateValid){
      let formattedFromDate = this.customProductService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPFromDate);
      let formattedToDate = this.customProductService.convertDateIntoYYYYMMDDFormat(this.form.value.finalQPToDate);

      if(moment(formattedToDate).isBefore(moment(formattedFromDate),'day')){
        this.isFinalQPToGreater=true;
        this.form.value.finalQPToDate = '';
      }else{
        this.isFinalQPToGreater=false;
      }
    }
    flag = this.isFinalQPToGreater || this.isFinalQPFromDateValid || this.isFinalQPToDateValid;

 
 
  return  flag;
}
checkifQPisselected(){
  let isOneQPSelected = false;
  if(this.a.isQPMultipleChoicesSelected==true){
   if(this.a.pricingOptionsEnum[0].qp){
    if(this.defaultValue=='' || this.defaultValue == null){
      isOneQPSelected = false;
    }
    else{
      isOneQPSelected = true;
    }
   }
   else{
    isOneQPSelected = false;
   }
  }
  else{
    isOneQPSelected = true; 
  }
  return isOneQPSelected;

}

Openmodal(){
  let dateValidationCheck:boolean;
  if(this.productInfo.combinedTenders[0].isQuotationPeriodUnrestricted  
    && (this.productInfo.combinedTenders[0].finalQPToDate!='undefined' || this.productInfo.combinedTenders[0].finalQPToDate!='' || this.productInfo.combinedTenders[0].finalQPToDate!=null) && (this.productInfo.combinedTenders[0].finalQPFromDate!='undefined' || this.productInfo.combinedTenders[0].finalQPFromDate!='' ||this.productInfo.combinedTenders[0].finalQPFromDate!=null)){
      if((this.productInfo.combinedTenders[0].pricingOptionsEnum.length == 1 && (this.productInfo.combinedTenders[0].pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE' || this.productInfo.combinedTenders[0].pricingOptionsEnum[0].pricingOptions=='LUMP_FIXED_PRICE'))){
        dateValidationCheck = this.checkQPdateValidation();
      }else if(this.productInfo.combinedTenders[0].pricingOptionsEnum.length>1 && this.priceTab != 'FIXED_PRICE'){
        dateValidationCheck = this.checkQPdateValidation();
      }else{
        dateValidationCheck = false;
      }
  }else{
    if(this.a.pricingOptionsEnum[0].qp){
      if(this.a.pricingOptionsEnum[0].qp[0].description == 'Fixed QP' && (this.form.value.finalQPFromDate == undefined || this.form.value.finalQPToDate == undefined)){
        this.defaultValue = this.a.pricingOptionsEnum[0].qp[0].description;
        this.isFinalQPFromDateValid = true;
        this.isFinalQPToDateValid = true;
        this.displayFixedQPSection =true;
        dateValidationCheck = true;
      } else{        
        dateValidationCheck =false;
      }
    }else{
      dateValidationCheck = false;
    }
    //dateValidationCheck = false;
  }
   
  let proceedFurther:boolean = this.checkpriceEnteredorNot();
  let QPValuSelectedlocal = this.checkifQPisselected();
      if(!proceedFurther && !dateValidationCheck && QPValuSelectedlocal==true){
        const ModalRef = this.modalService.open(TenderPricingOptionConfirmBidComponent,{centered: true,size:'md'});
        ModalRef.componentInstance.quantityshw = this.quantityshw;
        ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
        ModalRef.componentInstance.isQuantityUnrestricted = this.a.isQuantityUnrestricted;
        ModalRef.componentInstance.finalQPFromDate=this.qpSD? this.qpSD:this.a.finalQPFromDate;
        ModalRef.componentInstance.finalQPToDate=this.qpED?this.qpED:this.a.finalQPToDate;
        if (this.productInfo?.combinedTenders.length ==1){
         

          if( this.productInfo ?.combinedTenders[0].minimumQuantity && this.productInfo ?.combinedTenders[0].maximumQuantity){
          if(this.productInfo ?.combinedTenders[0].pricingOptionsEnum.length>1){  
            ModalRef.componentInstance.quantity=this.quantity;
            }
            if(this.productInfo ?.combinedTenders[0].pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE' ||this.productInfo ?.combinedTenders[0].pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE'){
                ModalRef.componentInstance.quantity=this.value;
            }
          }
          ModalRef.componentInstance.datePeriod=this.productInfo;
          console.log(this.productInfo,'productInfo')
          ModalRef.componentInstance.code=this.productInfo ?.combinedTenders[0];
         
        }else{
                ModalRef.componentInstance.datePeriod=this.selectProduct;
                ModalRef.componentInstance.code=this.productsEntry;
                if( this.productInfo ?.combinedTenders[0].minimumQuantity && this.productInfo ?.combinedTenders[0].maximumQuantity){
                  if(this.productInfo ?.combinedTenders[0].pricingOptionsEnum.length>1){
                  ModalRef.componentInstance.quantity=this.quantity;
                }
                if(this.productInfo ?.combinedTenders[0].pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE' || this.productInfo ?.combinedTenders[0].pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE'){
                    ModalRef.componentInstance.quantity=this.value;
                }
              }
        }
        // if(this.productInfo.finalQPFromDate && this.productInfo.finalQPToDate){
        //   this.qpDatesRequired = true;
        // }else{
        //   this.qpDatesRequired = false;
        // }
        
              if(this.productInfo.commodityType=='CN'){
                ModalRef.componentInstance.price=this.price;
                ModalRef.componentInstance.indexPrice = this.productInfo?.combinedTenders[0].displayRCPriceConfig.displayRCPrice == true ? this.indexPrice : '';  
              }else{
                ModalRef.componentInstance.price=this.price;
              }
        ModalRef.componentInstance.tabName = this.priceTab;
        this.ActiveModal.close();
      }
      else{
        if(QPValuSelectedlocal == false){
          this.QPValuSelectedError = true;
        }
        else{
          this.QPValuSelectedError = false;
        }
      }
    
}
getPrefix(priceOptions,commodityType){
  return this.customProductService.getPrefix(priceOptions,commodityType)

}
getLabel(priceOptions,commodityType){
  return this.customProductService.getLabel(priceOptions,commodityType);
}
getUnit(priceOptions,commodityType){
  return this.customProductService.getUnit(priceOptions,commodityType);
}
  backToPlacebid(){
    
    if(this.productInfo?.combinedTenders.length >1){
      this.ActiveModal.close();
      const ModalRef = this.ModalService.open(TenderSelectProductsComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.productsInfo =  this.selectProduct;
      if(this.selectProduct.pricingOptionsEnum[0]?.qp){
        ModalRef.componentInstance.defaultValue = this.selectProduct?.pricingOptionsEnum[0]?.qp[0]?.description;
        if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
          ModalRef.componentInstance.displayFixedQPSection = true;
          ModalRef.componentInstance.finalQPFromDate=this.selectProduct.finalQPFromDate;
          ModalRef.componentInstance.finalQPToDate=this.selectProduct.finalQPToDate;
        }else{
          ModalRef.componentInstance.displayFixedQPSection = false;
        }
      }
     this.checkbox=this.productsEntry;
     this.checkbox.map(val=>{
         val.checked = true;
         ModalRef.componentInstance.parameter = this.productsEntry;
     })
    // if(this.productInfo.finalQPFromDate && this.productInfo.finalQPToDate){
    //   this.qpDatesRequired = true;
    // }else{
    //   this.qpDatesRequired = false;
    // }
    }
  }
 
  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,4})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);
 
    if (!reg.test(input)) {
        event.preventDefault();
    }
 }
 formatQPDates(data){
  return this.customProductService.formatQPDates(data);
}

  changeQuantity(action,step){
    let currentValue;
    if(action == 'decrease'){
      currentValue = this.value - 5000;
      currentValue >= this.a.minimumQuantity? this.value = currentValue: this.value;
      
    }else if(action == 'increase'){
      currentValue= this.value + 5000;
      currentValue <= this.a.maximumQuantity? this.value = currentValue : this.value;
    }
  }
  getPricingBasisBasedOnOption(pricingOption,description){
    return this.customProductService.getPricingBasisBasedOnOption(pricingOption,description)
  }
}

